<template>
    <v-dialog 
        :value="show"
        fullscreen 
        hide-overlay 
        @keydown.esc="close"
        transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn 
                    icon 
                    dark 
                    :disabled="saving" 
                    @click="close">
                    <v-icon large>close</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    <span v-if="editedItem && editedItem.TeamID">Edit Team</span>
                    <span v-else>Add New Team</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-form ref="editForm" v-model="editValid">
                <v-layout class="dialog-content">
                    <v-flex xs12 md6 offset-md3 mt-4>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field 
                                    label="Name"
                                    v-model="editedItem.Name"
                                    :rules="[$ValidationRules.rules.required]"
                                >
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-autocomplete
                                    label="Work Types"
                                    :items="$Constants.WORK_TYPES_ARRAY_NO_EXTRAS"
                                    item-value="WorkTypeID"
                                    item-text="Name"
                                    v-model="editedItem.WorkTypeID"
                                >
                                </v-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <v-checkbox
                                    v-model="editedItem.IsActive"
                                    label="Active"
                                >
                                </v-checkbox>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap class="dialog-action-buttons">
                            <v-flex xs12 sm6>
                                <v-btn 
                                    block 
                                    color="success" 
                                    :disabled="!editValid" 
                                    :loading="saving" 
                                    @click="save">
                                    <span>Save</span>
                                </v-btn>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-btn 
                                    block 
                                    color="error" 
                                    :disabled="saving" 
                                    @click="close">
                                    <span>Cancel</span>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-alert 
                                    :value="error" 
                                    outline 
                                    type="error">
                                    <span>{{ error }}</span>
                                </v-alert>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import ConfigurationAPI from "@/api/plantConfigurationApi";
import BaseAPI from "@/api/baseApi";

export default {
    props: {
        originalItem: {
            required: false,
            type: Object,
            default: null
        },
        show: {
            required: true,
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            editedItem: {},

            saving: false,
            error: null,

            editValid: false
        }
    },
    computed: {
        
    },
    mounted() {
        
    },
    methods: {
        close(saved) {
            this.$emit("close", saved);
        },
        async save() {
            try {
                this.saving = true;
                this.error = null;

                await ConfigurationAPI.saveTeam(this.editedItem);

                this.close(true);
            }
            catch (err) {
                this.error = await BaseAPI.parseHttpRequestError(err);
                throw err;
            }
            finally {
                this.saving = false;
            }
        },
    },
    watch: {
        show: {
            handler(newVal, oldVal) {
                // we are showing the add edit dialogue - update the editedItem data and reset some UI things
                if (newVal != oldVal && newVal) {
                    // clear previous error message
                    this.error = null;

                    this.editedItem = JSON.parse(JSON.stringify(this.originalItem));

                    if (!this.editedItem.TeamID) {
                        // default active checkbox on when we are adding a new team
                        this.editedItem.IsActive = true;
                    }
                }
            },
            deep: true
        }
    },
}
</script>